import createReducer from '../lib/createReducer';
import * as types from '../actions/types';

const initialState = {
  visible: true,
};

export const welcomeScreenReducer = createReducer(initialState, {
  [types.HIDE_WELCOME_SCREEN](state) {
    return {
      ...state,
      visible: false,
    };
  },
});
